var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showHighGasWarning)?_c('div',{staticClass:"white window high-gas-price-info"},[_vm._v(" The Ethereum blockchain is currently experiencing high usage, making it unusually expensive to use. Consider waiting to use Curve. ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }